import React, { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Col, Container, Row } from "react-bootstrap"
import DataTable from "react-data-table-component"
import CompanySelector from "ATSComponents/Common/CompanySelector"
import OrgTableShimmer from "ATSComponents/Common/OrgTableShimmer"
import axios from "axios"
const LoginActivityLogs = () => {
  document.title = "ATS - Login Activity Logs";
  const dispatch = useDispatch()
  const { first, rows } = useSelector(state => state.calendar.pagination)
  const userInfos = JSON.parse(sessionStorage.getItem("atsuser-info"))
  const token = userInfos?.access_token
  const initialCompanyId =
    userInfos?.user_details?.companies_data?.[0]?.company_id
  const [totalRows, setTotalRows] = useState(0)
  const [companyId, setCompanyId] = useState(initialCompanyId)
  const [loginActivities, setLoginActivities] = useState([])
  const [loading, setLoading] = useState(false)
  const fetchLoginActivity = async (company_id, page = 1, size = 10) => {
    setLoading(true)
    try {
      const response = await axios.get(
        `/api/v1/login-activity/?company_id=${company_id}&page=${page}&size=${size}`
      )
      if (response.status === 200) {
        setLoginActivities(response?.data?.results || [])
        setTotalRows(response.data.count || 0)
      }
    } catch (error) {
      console.error("Login activity error:", error)
    } finally {
      setLoading(false)
    }
  }
  const [page, setPage] = useState(1)
  const [size, setSize] = useState(10)
  useEffect(() => {
    if (companyId) {
      fetchLoginActivity(companyId, page, size)
    }
  }, [companyId, page, size])
  // useEffect(() => {
  //   if (companyId) {
  //     fetchLoginActivity(companyId)
  //   }
  // }, [companyId])
  const handleCompanyChange = company => {
    if (company?.company_id) {
      setCompanyId(company.company_id)
      setPage(1)
    }
  }
  const columns = [
    {
      name: <strong>SNo</strong>,
      width: "80px",
      cell: (row, index) => index + 1,
      sortable: true,
    },
    {
      name: <strong>First Name</strong>,
      selector: row => row.first_name || "-",
      sortable: true,
    },
    {
      name: <strong>Middle Name</strong>,
      selector: row => row.middle_name || "-",
      sortable: true,
    },
    {
      name: <strong>Last Name</strong>,
      selector: row => row.last_name || "-",
      sortable: true,
    },
    {
      name: <strong>IP Address</strong>,
      selector: row => row.ip_address || "-" ,
      sortable: true,
    },
    {
      name: <strong>Hostname</strong>,
      selector: row => row.hostname || "-",
      sortable: true,
    },
    {
      name: <strong>User Agent</strong>,
      selector: row => row.user_agent || "-",
      wrap: true,
      sortable: true,
    },
    {
      name: <strong>Logged At</strong>,
      selector: row => new Date(row.logged_at).toLocaleString() || "-",
      sortable: true,
    },
  ]
   const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "All",
    }

  return (
    <div className="page-content allact-tabs">
      <Container fluid={true}>
        <div className="page-title-box actjobbread mb-0">
          <Row className="align-items-center actjobsum">
            <Col sm={6} md={6} lg={8}>
              <h1 className="page-title">Login Activity Report</h1>
            </Col>
          </Row>
          <Row className="mb-3">
            {/* <Col xxl={2}>
                        <select className="form-control">
                            <option value="">-- Select --</option>
                            <option value="successful">Successful Logins</option>
                            <option value="unsuccessful">Unsuccessful Logins</option>
                        </select>
                    </Col> */}
            <Col xxl={6} className="ms-auto d-flex justify-content-end">
              <label className="mt-2 me-2">Select Company</label>
              <div style={{ width: "170px" }}>
                <CompanySelector onCompanyChange={handleCompanyChange} />
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div
                className="AllLoginActivitysCandy_TableView"
                id="AllLoginActivitysCandy_TableView"
              >
                <DataTable
                  columns={columns}
                  data={loginActivities}
                  progressPending={loading}
                  progressComponent={<OrgTableShimmer columns={5} rows={6} titleWidth="220px" />}
                  pagination
                  paginationServer
                  fixedHeader
                  fixedHeaderScrollHeight="550px"
                  paginationComponentOptions={paginationComponentOptions}
                  paginationTotalRows={totalRows}
                  onChangePage={newPage => setPage(newPage)}
                  onChangeRowsPerPage={newSize => {
                    setSize(newSize)
                    setPage(1)
                  }}
                  highlightOnHover
                  striped
                />
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  )
}
export default LoginActivityLogs
